import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import PageContent from "../../components/PageContent";
import ListPageToolbar from "../../components/ListPageToolbar";
import { useConstants } from "../../hooks/UseConstants";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PageHero from "../../components/motion/PageHero";
import ScrollReveal from "../../components/motion/ScrollReveal";
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { resolveCourseImage } from "../../helper/resolveMediaUrl";
import GridMediaCard from "../../components/cards/GridMediaCard";
import Fetch from "../../services/Fetch";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../../components/DialogView";
import SnackbarAlert from "../../components/SnackBar";
import { useDialog } from "../../hooks/UseDialog";
import useSnackBar from "../../hooks/UseSnackBar";
import { useWaits } from "../../hooks/UseWait";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

function Courses() {
     const { host, language } = useConstants();
     const { wait } = useContext(AuthContext);
     const {open, title, description, setDialog, setOpen} = useDialog();
     const {openSnackBar, type, message, setSnackBar, setOpenSnackBar} = useSnackBar();
     const {getWait, setGetWait, searchWait, setSearchWait, sendWait, setSendWait} = useWaits();
     const [courses, setCourses] = useState([]);
     const [categories, setCategories] = useState([]);
     const [categoryId, setCategoryId] = useState('');
     const [search, setSearch] = useState('');
     const [courseId, setCourseId] = useState('');
     const navigate = useNavigate();

     const getCategories = async () => {
          const result = await Fetch(`${host}/categories?per_page=100`, "GET", null);
          const { items } = parsePaginatedResponse(result);
          setCategories(items);
     }

     const getCourses = async () => {
          setSearchWait(true);

          const params = new URLSearchParams({
               teacher_id: localStorage.getItem('id'),
               per_page: '100',
          });
          if (categoryId) params.set('category_id', categoryId);
          if (search?.trim()) params.set('search', search.trim());

          const result = await Fetch(`${host}/courses?${params.toString()}`, 'GET', null);

          if (result.status === 200) {
               const { items } = parsePaginatedResponse(result);
               setCourses(items);
          } else {
               setCourses([]);
          }

          setSearchWait(false);
     }

     const deleteCourse = async () => {
          setSendWait(true);

          let result = await Fetch(host + `/teacher/courses/${courseId}/delete`, 'DELETE', null);

          if (result.status == 200) {
               setCourses(prevCourses => prevCourses.filter(course => course.id !== courseId));
               setOpen(false);
               setSnackBar('success','Deleted Successfully');
               setCourseId(null);
          }


          setSendWait(false);
     }

     useEffect(() => {
          getCategories();
          getCourses();
          setGetWait(false);
     }, []);

     useEffect(() => {
          getCourses();
     }, [categoryId, search]);

     return (
          <>
               <PageContent wait={wait} loading={getWait}>
                    <PageHero
                        title={language === 'ar' ? 'دوراتي' : 'My Courses'}
                        subtitle={language === 'ar' ? 'إدارة دوراتك المنشورة' : 'Manage your published courses'}
                        icon={<MenuBookOutlinedIcon />}
                    />
                    <ListPageToolbar
                         data={categories}
                         selected={categoryId}
                         onChange={setCategoryId}
                         onSearch={setSearch}
                    />
                    {
                         searchWait ?
                              <Box className="w-full flex justify-center items-center py-16">
                                   <CircularProgress size={70} />
                              </Box>
                              :
                              <Box className="grid grid-cols-3 gap-5 max-sm:grid-cols-1 justify-items-center">
                                   {
                                        courses.map((course, index) => (
                                            <ScrollReveal key={course.id || index} delay={index * 50} direction="up" className="w-full">
                                                            <GridMediaCard
                                                                 image={resolveCourseImage(course)}
                                                                 title={language === 'en' ? course.name_en : course.name_ar}
                                                                 description={language === 'en' ? course.description_en : course.description_ar}
                                                                 actions={
                                                                      <>
                                                                           <Button onClick={() => navigate(`/course-details/${course.id}`)} size="small" variant="contained" sx={{ bgcolor: '#0D358C' }}>
                                                                                {language === 'ar' ? 'عرض' : 'View'}
                                                                           </Button>
                                                                           <Button onClick={() => navigate(`/update-course/${course.id}`)} size="small" variant="outlined">
                                                                                {language === 'ar' ? 'تعديل' : 'Update'}
                                                                           </Button>
                                                                           <Button size="small" color="error" variant="outlined" onClick={() => { setCourseId(course.id); setDialog(language === 'ar' ? 'حذف الدورة' : 'Delete Course', language === 'ar' ? 'هل أنت متأكد من حذف هذه الدورة؟' : 'Are you sure that you want to delete this course?') }}>
                                                                                {language === 'ar' ? 'حذف' : 'Delete'}
                                                                           </Button>
                                                                      </>
                                                                 }
                                                            />
                                            </ScrollReveal>
                                                       ))
                                   }
                              </Box>
                    }
                    <AlertDialog title={title} description={description} onCancel={() => setOpen(false)} onConfirm={deleteCourse} wait={sendWait} openDialog={open} />
               </PageContent>
               <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
          </>
     );
}

export default Courses;